import { Text } from '@pinchenterprisesnpm/friday-ui'
import styled from 'styled-components'

export const CustomValidationError = styled(Text)`
  color: ${({ theme: { palette } }) => palette.danger};
  font-size: ${({ theme: { font } }) => font.sizes.small};
`
